import { CJEvent } from 'types/event';
import { FicheDePrep } from 'types/sequences';
import { v4 as uuid } from 'uuid';

export function getFicheDePrepFromCJEvent(
  event: CJEvent,
  sequenceId?: string,
): FicheDePrep {
  return {
    id: uuid(),
    sequenceId,
    title: event.title,
    niveaux: [],
    bo: {
      domaine: event.bo.domaine,
      cycle: event.bo.cycle,
      competence: event.bo.competence,
      matiere: event.bo.matiere || [],
      goals: event.bo.goals,
    },
    materials: event.materials,
    customFields: event.customFields,
    attachments: event.attachments,
    phases: [
      {
        id: uuid(),
        title: 'Phase 1',
        dureeInMinute: 10,
        customFields: [],
        flow: event.flow,
        types: [],
      },
    ],
  };
}
